// services/listingPerformanceApi.js
//
// «أداء الوحدات» — the weekly performance page API (tasks/property-performance-phase1.md step 5) on the
// shared secureApi instance; the auth header is attached automatically. Each call returns the parsed body.
//
// Writes pass `preserveBackendError` so the page reads the backend's stable `code` (LISTING_PERF_xxx) and
// translates it (config/listingPerformanceLabels.js), instead of secureApi's generic text.
//
// The collector's upload (POST /submissions) is NOT here: it is sent by the weekly routine with a
// submit-only key, never from a browser.

import { secureApi } from './secureApi';

const BASE = '/api/v1/listing-performance';
const KEEP_CODE = { preserveBackendError: true };

const listingPerformanceApi = {
  /** The whole page: week list, the three tabs, last upload. The week and owner cut are the server's. */
  getBoard: async ({ ownerId, week, view }) => (await secureApi.get(`${BASE}/board`, {
    params: { ...(ownerId ? { ownerId } : {}), ...(week ? { week } : {}), ...(view ? { view } : {}) },
    ...KEEP_CODE
  })).data,
  getUnit: async ({ unitCode, ownerId, week, view }) => (await secureApi.get(`${BASE}/units/${encodeURIComponent(unitCode)}`, {
    params: { ...(ownerId ? { ownerId } : {}), ...(week ? { week } : {}), ...(view ? { view } : {}) },
    ...KEEP_CODE
  })).data,

  /** «أتفق» / «لا أتفق» on the reading the page showed — `generatedAt` names it (a refreshed one → 409). */
  reviewBrief: async ({ unitCode, week, verdict, reason, generatedAt }) => (await secureApi.post(
    `${BASE}/units/${encodeURIComponent(unitCode)}/brief/review`,
    { verdict, reason: reason || null, generatedAt },
    { params: { week }, ...KEEP_CODE }
  )).data,
  /** «إعادة القراءة» — marks it pending; the reading arrives on a later read of the unit. */
  rerunBrief: async ({ unitCode, week }) => (await secureApi.post(
    `${BASE}/units/${encodeURIComponent(unitCode)}/brief`, {}, { params: { week }, ...KEEP_CODE }
  )).data,

  createChange: async (body) => (await secureApi.post(`${BASE}/changes`, body, KEEP_CODE)).data,
  updateChange: async ({ id, changes }) => (await secureApi.patch(`${BASE}/changes/${id}`, changes, KEEP_CODE)).data,

  getThresholds: async () => (await secureApi.get(`${BASE}/thresholds`)).data,
  /** `{ values: { …all six… }, reason }` — admin only. */
  saveThresholds: async (body) => (await secureApi.put(`${BASE}/thresholds`, body, KEEP_CODE)).data,

  getKeys: async () => (await secureApi.get(`${BASE}/keys`)).data,
  /** `{ name, userId }` — the plain key is in this answer only. */
  createKey: async (body) => (await secureApi.post(`${BASE}/keys`, body, KEEP_CODE)).data,
  revokeKey: async ({ id }) => (await secureApi.post(`${BASE}/keys/${id}/revoke`, {}, KEEP_CODE)).data,
  getSubmissions: async () => (await secureApi.get(`${BASE}/submissions`, { params: { limit: 10 } })).data
};

export default listingPerformanceApi;
